export default "__VITE_ASSET__nGZWugih__"